<template>
  <div class="homepage">
    <TopNotice v-if="topNotices&&topNotices.length" :notices="topNotices" />
    <MidNotice v-if="midNotices&&midNotices.length" :notices="midNotices" />
    <div class="banner-area" v-if="bannerTexts&&bannerTexts.length">
      <BannerTexts :bannerTexts="bannerTexts" @bannerItemClicked="openCourseDetail" />
    </div>
    <div class="banner-imgs" v-if="bannerImgs&&bannerImgs.length">
      <BannerImages :images="bannerImgs" @bannerItemClicked="openCourseDetail" />
    </div>
    <Modal class-name="code-detail" width='550' v-model="showCodeDetail">
      <p slot="header">验证门票</p>
      <div class="code-detail-info">
        <h4 class="code-detail-title">{{codeItem.dealInfo.poiName}}&nbsp;|&nbsp;{{codeItem.dealInfo.ticketTypeName}} </h4>
        <div v-if="codeItem.orderInfo.orderSource === 4" class="from-package-product">
          <p>此订单来自打包产品：{{codeItem.mainOrderInfo.title}}</p>
        </div>
        <div class="price-valid-date">
          <label>购买单价：</label>
          <span class="code-detail-money">
            <span class="unit">￥</span>{{codeItem.orderInfo.price}}</span>
          <label> 有效期：</label>
          <span class="code-detail-validdate">{{codeItem.voucherInfo.voucherDateBegin}} 至 {{codeItem.voucherInfo.voucherDateEnd}}</span>
        </div>
        <div class="cost-detail-part" v-if="codeItem.dealInfo.costDetail&&codeItem.dealInfo.costDetail.length">
          <h4 class="cost-detail-title">费用包含：</h4>
          <ol class="cost-details">
            <li v-for="item in codeItem.dealInfo.costDetail" :key="item">
              {{item}}
            </li>
          </ol>
        </div>
        <div class="code-use-info">
          <label>查询券号：</label>
          <span>{{codeFormated(codeItem)}}</span>
          <label>可消费门票：</label>
          <span>{{codeItem.orderInfo.canUse}}</span>
        </div>
        <div class="code-order-info">
          <label>订单号：</label>
          <span>
            <a href="javascript:void(0)" @click.stop.prevent="openOrderDetail(codeItem.orderInfo.orderId)">{{codeItem.orderInfo.orderId}}</a>
            <br/>
            <span class="from-package-product" v-if="codeItem.orderInfo.orderSource === 4 ">(打包订单号：{{codeItem.mainOrderInfo.orderNo}})</span>
          </span>
          <label>购买时间：</label>
          <span>{{codeItem.orderInfo.createDate}}</span>
        </div>
        <div class="voucher-holder" v-if="codeItem.voucherInfo.holder && codeItem.voucherInfo.holder.length">
          <ul>
            <li v-for="item in codeItem.voucherInfo.holder" :key="item.dataStr">
              <label>{{dataMap[item.key]}}:</label>
              <span>{{item.dataStr}}</span>
            </li>
          </ul>
        </div>
        <div class="credentials-info" v-if="codeItem.voucherInfo.credentials && codeItem.voucherInfo.credentials.length">
          <ul>
            <li v-for="person in codeItem.voucherInfo.credentials" :key="person.credentialsAllInfo">
              <span v-if="person.bookInfo">
                {{person.credentialsAllInfo}}
              </span>
              <Button type="primary" size='small' :key="person.credentialsAllInfo" v-clipboard:copy="person.credentialsAllInfo">复制</Button>
            </li>
          </ul>
        </div>
        <div class="voucher-code" v-if="codeItem.orderInfo.canUse">
          验证
          <Select v-model="codeCount" size="small">
            <Option v-for="num in codeItem.orderInfo.canUse" :value="num" :key="num">{{num}}</Option>
          </Select>张，总价
          <span class="price">￥{{totalPrice}}</span>
        </div>
        <div class="code-no-canuse" v-if="!codeItem.orderInfo.canUse">
          验证此订单门票均已消费/退款，无法验证
        </div>
        <div class="verify-btn" v-if="codeItem.orderInfo.canUse">
          <Button type="success" :disabled="!codeCount" long @click="verifyCode(false)">验证</Button>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal class-name="code-result" width='550' v-model="showCodeResult">
      <p slot="header">验证成功</p>
      <div class="code-result-info">
        <h4>{{codeItem.dealInfo.poiName}}&nbsp;|&nbsp;{{codeItem.dealInfo.ticketTypeName}}</h4>
        <section class="code-count-info">
          <p>{{codeFormated(codeItem)}} * {{codeCount}}张</p>
        </section>
        <section class="code-verify-info">
          <p>
            <label>订单号：</label>
            <span>{{codeItem.orderInfo.orderId}}</span>
          </p>
          <p>
            <label>成功数量：</label>
            <span>{{codeCount}}张 * ￥{{codeItem.orderInfo.price}}</span>
          </p>
          <p>
            <label>总金额：</label>
            <span>￥{{totalPrice}}</span>
          </p>
        </section>
        <section class="fee-info" v-if="codeItem.dealInfo.costDetail&&codeItem.dealInfo.costDetail.length">
          <h4 class="cost-detail-title">费用包含：</h4>
          <ol class="cost-details">
            <li v-for="item in codeItem.dealInfo.costDetail" :key="item">
              {{item}}
            </li>
          </ol>
        </section>
        <section class="credentials-info" v-if="codeItem.voucherInfo.credentials && codeItem.voucherInfo.credentials.length">
          <ul>
            <li v-for="person in codeItem.voucherInfo.credentials" :key="person.credentialsAllInfo">
              <label>游玩人：</label>
              <span v-if="person.credentialsAllInfo">
                {{person.credentialsAllInfo.replace('取票人：','')}}
              </span>
              <Button type="primary" size='small' v-if="person.credentialsAllInfo" :key="person.credentialsAllInfo" v-clipboard:copy="person.credentialsAllInfo">复制</Button>
            </li>
          </ul>
        </section>
      </div>
      <div slot="footer">
        <Button type="success" long @click="closeVerifyResult()">确定</Button>
      </div>
    </Modal>
    <div class="flex-row">
      <HomePageCard class="verify-card" title='美团券验证'>
        <Input v-model="code" placeholder="请输入美团券码" :maxlength="14" :disabled="isCodeRequesting" autocomplete='off' element-id="ticketHomeVoucherCodeInput" @on-change="codeChanged" class="code-input">
        <Button type="primary" slot="append" :loading="isCodeRequesting" :disabled="!code || isCodeRequesting" @click="verify">验证</Button>
        </Input>
        <div class="action-area">
          <div>
            <a href="javascript:void(0)" @click.stop.prevent="revokeVerify">
              <Icon type="turbo-ui-revoke" />撤销验证</a>
            <a href="javascript:void(0)" @click.stop.prevent="verifyHistory">
              <Icon type="turbo-ui-history" />验证历史</a>
          </div>
        </div>
      </HomePageCard>
      <HomePageCard class="yesterday-data" title='昨日数据' extra="更多" @extraClick="moreYesterdayData()">
        <div class="data-area">
          <DataItem v-for="data in yesterdayDatas" @click.native="navToDataSummary" :key="data.name" :valueUnit="data.unit" :name="data.name" :value="data.value" :hasCompareValue="true" compareName="较上周同期" :compareValue="data.compareValue" />
        </div>
      </HomePageCard>
    </div>
    <div class="flex-row">
      <HomePageCard class="yuyue-ticket" title="预约票量">
        <div class="ticket-count">
          <DataItem v-for="data in orderTicketsData" :key="data.id" :id="data.id" :extra="data.extra" valueUnit="件" :name="data.name" :value="data.value" />
        </div>
      </HomePageCard>
    </div>
    <div class="flex-row">
      <HomePageCard class="recomm-services" title="推荐服务">
        <div>
          <template v-for="data in serviceItems">
            <ServiceItem :key="data.name" v-if="data.icon!=='app'" @click.native="servicItemClicked(data)" :icon="data.icon" :name="data.name" :desc="data.desc" />
            <Tooltip v-if="data.icon==='app'" :key="data.name" placement="top">
              <ServiceItem :key="data.name" :icon="data.icon" :name="data.name" :desc="data.desc" :delay='350' />
              <img src="//p0.meituan.net/codeman/8acc947084d6b22070523f39dcb7c91428173.png" width='226px' slot="content" />
            </Tooltip>
          </template>
        </div>
      </HomePageCard>
      <HomePageCard class="recomm-actives" title="推荐活动">
        <ul v-if="activeItems&&activeItems.length">
          <ActiveItem v-for="data in activeItems" :key="data.id" :name="data.name" @click.native="activityItemClicked(data.id)" :date="data.date" :bgclass="data.bg" />
        </ul>
        <div class="create-selfpro" v-else>
          <div>
            <p class="main-desc">暂无可参加的活动</p>
            <p class="sub-desc">自己做促销，同样可以吸引顾客</p>
            <Button type="primary" @click="createSelfPro">创建自促活动</Button>
          </div>
        </div>
      </HomePageCard>
    </div>
    <div class="flex-row">
      <div class="notices">
        <Notices title='平台公告' :notices="notices" @extraClicked="moreNotices(3)" />
        <Notices title="规则中心" :notices="rules" @extraClicked="moreNotices(10)" />
      </div>
      <HomePageCard class="xigua-academy" title="西瓜学院" extra="更多" @extraClick="moreNotices(5)">
        <ul class="course-list">
          <CourseItem v-for="courseItem in courses" @click.native="openCourseDetail(courseItem.id)" :key="courseItem.id" :src="courseItem.src" :title="courseItem.title" :subTitle="courseItem.subTitle" />
        </ul>
      </HomePageCard>
    </div>
    <HomePageFooter/>
  </div>
</template>
<script>
  import HomePageCard from "components/homepage/Card.vue";
  import DataItem from "components/homepage/dataItem.vue";
  import ServiceItem from "components/homepage/serviceItem.vue";
  import ActiveItem from "components/homepage/ActiveItem.vue";
  import NoticeItem from "components/homepage/noticeItem.vue";
  import CourseItem from "components/homepage/CourseItem.vue";
  import HomePageFooter from "components/homepage/Footer.vue";
  import MidNotice from "components/homepage/MidNotices";
  import MomentFormat from "views/dataPlatform/filters/moment-format";
  import menpiaoDataPlatform from "api/menpiaoDataPlatform";
  import { getReserveData } from "api/dataCenter.js";
  import { otpHost } from "config/env.conf";
  import {
      getSignUpActivities,
      getAnnounces,
      codeDetail,
      getMainOrderInfo,
      verify
  } from "api/ticket";
  import { getNoticeDetailUrl } from "utils/notices";
  import Notices from "components/homepage/notices.vue";
  import { mapActions } from "vuex";
  import BannerTexts from "components/homepage/BannerTexts";
  import BannerImages from "components/homepage/BannerImages";
  import TopNotice from "components/homepage/TopNotice";
  import CodeDetailDialog from "components/homepage/CodeDetail";
  import { falconReport } from "utils/falconReport";
  import Vue from "vue";
  Vue.component("CodeDetailDialog", CodeDetailDialog);
  import Moment from "moment";
  const yestodayStr = MomentFormat.getYestoday();
  const salePlatform = 0;
  const fixedNum = 2;
  const bgIndexMap = { 0: "first", 1: "second" };
  const bizLineId = 2;
  let tomorrowStr = Moment()
      .add(Moment.duration(1, "d"))
      .format("MM-DD");
  let afterTomorrowStr = Moment()
      .add(Moment.duration(2, "d"))
      .format("MM-DD");
  let noNumReg = /[^\d]*/g;
  const dataMap = {
      name: "取票人",
      mobile: "手机",
      credentials: "身份证",
      email: "邮箱",
      pinyin: "拼音"
  };
  const defaultCodeItem = { dealInfo: {}, orderInfo: {}, voucherInfo: {} };
  const bizLinePrefix = "ticket";

  export default {
      data: function() {
          return {
              bizLineId: bizLineId,
              code: "",
              bannerTextIndex: null,
              yesterdayDatas: [
                  {
                      name: "销售额",
                      value: null,
                      unit: "元",
                      compareValue: null
                  },
                  {
                      name: "销售量",
                      value: null,
                      unit: "件",
                      compareValue: null
                  },
                  {
                      name: "访购率",
                      value: null,
                      unit: "%",
                      compareValue: null
                  }
              ],
              orderTicketsData: [
                  {
                      name: "明天",
                      extra: tomorrowStr,
                      value: null
                  },
                  {
                      name: "后天",
                      extra: afterTomorrowStr,
                      value: null
                  },
                  {
                      name: "未来七天",
                      value: null
                  },
                  {
                      name: "未来三十天",
                      value: null
                  },
                  {
                      name: "有效期内未消费券数",
                      value: null
                  }
              ],
              serviceItems: [
                  {
                      id: 1,
                      icon: "zicu",
                      name: "商家自促",
                      desc: "精准投放，稳定拉新",
                      to: "ticketselfPromotionDealList"
                  },
                  {
                      id: 2,
                      icon: "app",
                      name: "手机App",
                      desc: "快捷便携，及时处理",
                      url: "//sj.qq.com/myapp/detail.htm?apkName=com.meituan.tripBizApp"
                  },
                  {
                      id: 3,
                      icon: "comment",
                      name: "评论管理",
                      desc: "维护客情，提升服务",
                      to: "ticketreviewlist"
                  },
                  {
                      id: 4,
                      icon: "datacenter",
                      name: "数据分析",
                      desc: "指标监控，销量提升",
                      to: "ticketreporterIndexData"
                  }
              ],
              activeItems: [],
              notices: [],
              rules: [],
              courses: [],
              bannerTexts: [],
              bannerImgs: [],
              topNotices: [],
              midNotices: [],
              codeItem: { dealInfo: {}, orderInfo: {}, voucherInfo: {} },
              codeCount: null,
              dataMap: dataMap,
              isCodeRequesting: false,
              showCodeDetail: false,
              showCodeResult: false
          };
      },
      components: {
          HomePageCard,
          DataItem,
          ServiceItem,
          ActiveItem,
          NoticeItem,
          CourseItem,
          HomePageFooter,
          Notices,
          BannerTexts,
          BannerImages,
          TopNotice,
          MidNotice
      },
      computed: {
          totalPrice() {
              if (
                  this.codeCount &&
          this.codeItem &&
          this.codeItem.orderInfo &&
          this.codeItem.orderInfo.price
              ) {
                  let price = Number.parseFloat(
                      this.codeItem.orderInfo.price * this.codeCount
                  );
                  if (price) {
                      return price.toFixed(2);
                  }
              }
              return 0;
          }
      },
      mounted() {
          this.codeInput = document.querySelector("#ticketHomeVoucherCodeInput");
      },
      created() {
          this.getYestodayData();
          this.getReserveData();
          this.getSignUpActivities();
          this.getNotices();
          this.getUser().then(bizUser => {
              if (bizUser && bizUser.directSign === 1) {
                  let dcServiceItem = this.serviceItems.find(serviceItem => {
                      return serviceItem.id === 4;
                  });
                  dcServiceItem.name = "客源分析";
                  dcServiceItem.desc = "地域分布，精准掌握";
                  dcServiceItem.to = "ticketcustomeResource";
              }
          });
      },
      methods: {
          moreYesterdayData() {
              this.$router.push({ name: bizLinePrefix + "reporterIndexData" });
          },
          codeChanged(ev) {
              let noNumReg = /[^\d]*/g;
              let couponCode = this.code;
              if (couponCode) {
                  couponCode = couponCode
                      .replace(noNumReg, "")
                      .replace(/([\d]{4})/g, "$1 ")
                      .trim();
                  this.$nextTick(() => {
                      this.code = couponCode;
                      if (this.code && this.code.length === 14) {
                          this.verify();
                      }
                  });
              }
          },
          verify() {
              let couponCode = this.code;
              if (couponCode) {
                  couponCode = this.code.replace(noNumReg, "");
                  if (couponCode && couponCode.length === 12) {
                      let codePrefix = couponCode.slice(0, 2);
                      if (
                          (Number.parseInt(codePrefix) > 31 || codePrefix === "00") &&
              codePrefix !== "88"
                      ) {
                          this.$Message.error({
                              content: "请核对是否正确的输入了12位券码。提示:订单号不能用于验证"
                          });
                      } else {
                          this.isCodeRequesting = true;
                          codeDetail(couponCode)
                              .then(response => {
                                  if (response && response.status === 0 && response.data) {
                                      this.codeItem = response.data;
                                      this.showCodeDetail = true;
                                      this.codeCount = null;
                                      this.codeItem.mainOrderInfo = {};
                                      this.formatCodeItem(this.codeItem);
                                      if (this.codeItem.orderInfo.orderSource === 4) {
                                          getMainOrderInfo({
                                              subOrderType: 2,
                                              subOrderNo: this.codeItem.orderInfo.orderId
                                          })
                                              .then(response => {
                                                  let data = response && response.data;
                                                  this.codeItem.mainOrderInfo = data.mainOrderInfo;
                                              })
                                              .catch(err => {
                                                  let msg = (err && err.message) || "获取订单信息出错";
                                                  this.$Message.error({ content: msg });
                                              });
                                      }
                                  }
                                  this.isCodeRequesting = false;
                              })
                              .catch(data => {
                                  if (data && data.status === 31) {
                                      this.$Modal.confirm({
                                          title: "验证团购券",
                                          okText: "去验证",
                                          cancelText: "关闭",
                                          onOK: () => {
                                              window.open(
                                                  "//e.meituan.com/#http://common.e.meituan.com/coupon/",
                                                  "_blank"
                                              );
                                          }
                                      });
                                  } else {
                                      let msg = (data && data.message) || "服务器错误，请重试";
                                      this.$Message.error({ content: msg });
                                      falconReport({
                                          metric: "otp.ticket.ticketVerify.fail",
                                          tags: `failMsg=验券失败${
                                              data.message ? "" : ",alertMsg=null"
                                          },status=${data.status}`,
                                          statusIgnored: [4]
                                      });
                                  }
                                  this.isCodeRequesting = false;
                              });
                      }
                  } else {
                      this.$Message.error("有效的美团券为12位数字");
                  }
              } else {
                  this.$Message.error("请输入美团券");
              }
          },
          revokeVerify() {
              this.$router.push({ name: "ticketvoucherRevert" });
          },
          verifyHistory() {
              this.$router.push({ name: "ticketvoucherHistory" });
          },
          ...mapActions(["getUser"]),
          getNotices() {
              getAnnounces(bizLineId)
                  .then(notices => {
                      if (notices) {
                          if (notices.notices) {
                              this.notices = notices.notices;
                          }
                          if (notices.rules) {
                              this.rules = notices.rules;
                          }
                          if (notices.midDialogDecorateList) {
                              this.midNotices = notices.midDialogDecorateList;
                          }
                          if (notices.courses) {
                              this.courses = notices.courses;
                          }
                          if (notices.bannerTexts) {
                              this.bannerTexts = notices.bannerTexts;
                          }
                          if (notices.bannerImages) {
                              this.bannerImgs = notices.bannerImages;
                          }
                          if (notices.topNotices) {
                              this.topNotices = notices.topNotices;
                          }
                      }
                  })
                  .catch(err => {
                      let msg = (err && err.data && err.data.message) || "获取公告出错";
                      this.error(msg);
                  });
          },
          getSignUpActivities() {
              getSignUpActivities(2, 2)
                  .then(activities => {
                      this.activeItems = activities.map((activity, index) => {
                          return {
                              id: activity.slotId,
                              name: activity.topActivityName + " " + slotName,
                              date: activity.startTime.substr(0, 10),
                              bg: bgIndexMap[index]
                          };
                      });
                  })
                  .catch(err => {
                      let errMsg = (err && err.data && err.data.message) || "网络错误";
                      this.error(errMsg);
                  });
          },
          getYestodayData() {
              this.isLoadingYestodayData = true;
              menpiaoDataPlatform
                  .getIndexData(salePlatform, yestodayStr, yestodayStr, false)
                  .then(res => {
                      if (res.status === 0) {
                          let sum = (res.data && res.data.sum) || null;
                          if (sum) {
                              let payAmount = sum.payAmount;
                              let payAmountPercent = this.getPercentNum(sum.payAmountPercent);
                              let payQuantity = sum.payQuantity;
                              let payQuantityPercent = this.getPercentNum(
                                  sum.payQuantityPercent
                              );
                              let visitPurchaseRate = this.getPercentNum(sum.visitPurchaseRate);
                              let visitPurchaseRatePercent = this.getPercentNum(
                                  sum.visitPurchaseRatePercent
                              );
                              this.yesterdayDatas.forEach(yesDataItem => {
                                  switch (yesDataItem.name) {
                                      case "销售额":
                                          yesDataItem.value = payAmount;
                                          yesDataItem.compareValue = payAmountPercent;
                                          break;
                                      case "销售量":
                                          yesDataItem.value = payQuantity;
                                          yesDataItem.compareValue = payQuantityPercent;
                                          break;
                                      case "访购率":
                                          yesDataItem.value = visitPurchaseRate;
                                          yesDataItem.compareValue = visitPurchaseRatePercent;
                                          break;
                                      default:
                                  }
                              });
                          }
                      }
                      this.isLoadingYestodayData = false;
                  })
                  .catch(err => {
                      let msg = (err && err.data && err.data.message) || "请求昨日数据失败";
                      this.error(msg);
                      this.isLoadingYestodayData = false;
                  });
          },
          getReserveData() {
              getReserveData()
                  .then(response => {
                      if (response && response.data) {
                          let dayNumber = response.data;
                          this.orderTicketsData.forEach(orderTicketItem => {
                              switch (orderTicketItem.name) {
                                  case "明天":
                                      orderTicketItem.value = dayNumber.tomorrow || 0;
                                      break;
                                  case "后天":
                                      orderTicketItem.value = dayNumber.afterTomorrow || 0;
                                      break;
                                  case "未来七天":
                                      orderTicketItem.value = dayNumber.week || 0;
                                      break;
                                  case "有效期内未消费券数":
                                      orderTicketItem.value = dayNumber.total || 0;
                                      break;
                                  case "未来三十天":
                                      orderTicketItem.value = dayNumber.month || 0;
                                      break;
                                  default:
                                      break;
                              }
                          });
                      }
                  })
                  .catch(err => {
                      console.log(err);
                      let msg = (err && err.data && err.data.message) || "请求预约票量失败";
                      console.error(msg);
                  });
          },
          error(msg) {
              this.$Notice.error({
                  title: msg,
                  message: null
              });
          },
          getPercentNum(num) {
              return Number.parseFloat(num)
                  ? (Number.parseFloat(num) * 100).toFixed(fixedNum)
                  : null;
          },
          servicItemClicked(item) {
              if (item.to) {
                  this.$router.push({ name: item.to });
                  return;
              }
              if (item.url) {
                  window.open(item.url, "_blank");
              }
          },
          navToDataSummary() {
              this.$router.push({ name: "ticketreporterIndexData" });
          },
          createSelfPro() {
              this.$router.push({ name: "ticketselfPromotionDealList" });
          },
          openCourseDetail(id) {
              window.open(getNoticeDetailUrl(id), "_blank");
          },
          activityItemClicked(id) {
              alert(id);
          },
          moreNotices(type) {
              switch (type) {
                  case 5:
                      this.$router.push({ name: "ticketacademy" });
                      break;
                  case 10:
                      this.$router.push({ name: "ticketpolicyrule" });
                      break;
                  case 3:
                      this.$router.push({ name: "broadcastticket" });
                      break;
                  default:
                      break;
              }
          },
          codeFormated(codeItem) {
              if (
                  codeItem &&
          codeItem.voucherInfo &&
          codeItem.voucherInfo.voucherCode
              ) {
                  let codeFormatReg = /([\d]{4})/g;
                  return codeItem.voucherInfo.voucherCode.replace(codeFormatReg, "$1 ");
              }
          },
          openOrderDetail(orderId) {
              window.open(
                  (otpHost + `/#/ticket/order/ticket/detail?id=${orderId}`).replace(
                      ".html/",
                      ".html"
                  ),
                  "_blank"
              );
          },
          verifyCode(_force) {
              if (
                  this.codeItem &&
          this.codeItem.voucherInfo &&
          this.codeItem.voucherInfo.voucherCode
              ) {
                  let voucherCode = this.codeItem.voucherInfo.voucherCode;
                  let verifyCount = this.codeCount;
                  if (voucherCode && verifyCount) {
                      verify({
                          voucherCode: voucherCode,
                          verifyCount: verifyCount,
                          manualConfirm: Boolean(_force)
                      })
                          .then(response => {
                              let data = response && response.data;
                              if (data.needConfirm) {
                                  this.$Modal.confirm({
                                      title: "确定验证",
                                      content: data.message,
                                      okText: "确定验证",
                                      cancelText: "放弃验证",
                                      onOk: () => {
                                          this.verifyCode(true);
                                      }
                                  });
                              } else {
                                  this.showCodeResult = true;
                              }
                          })
                          .catch(err => {
                              let msg = (err && err.message) || "验券错误";
                              this.$Message.error({ content: msg });
                          });
                  } else {
                      this.$Message.error("请选择验证张数");
                  }
              }
          },
          closeVerifyResult() {
              this.showCodeResult = false;
              this.codeItem = defaultCodeItem;
              this.code = "";
              this.showCodeDetail = false;
              this.codeCount = null;
          },
          formatCodeItem(couponInfo) {
              if (
                  couponInfo &&
          couponInfo.voucherInfo &&
          couponInfo.voucherInfo.credentials &&
          couponInfo.voucherInfo.credentials.length
              ) {
                  couponInfo.voucherInfo.credentials.forEach((item, index) => {
                      let results = [];
                      if (item.bookInfo && item.bookInfo.length) {
                          item.bookInfo.forEach((bookItem, bookIndex) => {
                              if (bookItem.dataStrMap) {
                                  bookItem.labelName =
                    couponInfo.credentialsType[
                        Object.keys(bookItem.dataStrMap)[0]
                    ];
                                  bookItem.labelValue = Object.values(bookItem.dataStrMap)[0];
                              } else {
                                  bookItem.labelName = dataMap[bookItem.key];
                                  bookItem.labelValue = bookItem.dataStr;
                              }
                              results.push(`${bookItem.labelName}：${bookItem.labelValue}`);
                          });
                      }
                      item.credentialsAllInfo = results.join(" ");
                  });
              }
          }
      }
  };
</script>
<style lang="scss">
@import "./../../components/homepage/_common.scss";
.homepage {
  background-color: #e9ecf2;
  padding: 20px;
  .banner-area,
  .banner-imgs {
    margin-bottom: 20px;
  }
  .flex-row {
    margin-bottom: 20px;
    display: flex;
    .verify-card {
      height: 200px;
      flex: 1 0 auto;
      width: 200px;
      .code-verify,
      .action-area {
        display: flex;
      }
      .action-area {
        user-select: none;
        margin-top: 30px;
        justify-content: center;
        & > div {
          a {
            color: #60666e;
            line-height: 20px;
            & .tbo-icon {
              margin-right: 10px;
            }

            &:hover,
            &:focus {
              color: #37a6fc;
              text-decoration: none;
            }
          }
          a:first-child {
            margin-right: 76px;
          }
        }
      }
      .code-input {
        height: 50px;
        border-radius: 2px;
        border: 0.5px #c6cacf solid;
        border-right: none;
        input {
          height: 50px;
          font-size: 24px;
          line-height: 50px;
          font-weight: 500;
          color: #555;
          border-right: none;
          padding-left: 20px;
        }
        .tbo-input:focus {
          border-color: #37a6fc;
          box-shadow: none;
        }
        .tbo-input-group-append,
        .tbo-btn-primary {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border: none;
        }
        .tbo-btn-primary {
          color: #fff;
          background-color: #0590fb;
          border-color: #0590fb;
          width: 100%;
          height: 50px;
          font-size: 16px;
          border: none;
        }
        .tbo-btn-primary:hover {
          color: #fff;
          background-color: #37a6fc;
          border-color: #37a6fc;
        }
        .tbo-input-group-append {
          width: 140px;
          padding: 0;
        }
      }
    }
    .yesterday-data {
      height: 200px;
      flex: 1 0 auto;
      width: 200px;
      .data-area {
        display: flex;
        .tbo-card-body {
          padding-top: 14px !important;
        }
        .data-item {
          cursor: pointer;
          flex: 1 0 auto;
          width: 50px;
        }
      }
    }
  }
  .yuyue-ticket {
    flex: 1 0 auto;
    height: 150px;
  }
  .recomm-services,
  .verify-card {
    margin-right: 20px;
  }
  .recomm-services,
  .recomm-actives {
    height: 226px;
    flex: 1 0 auto;
    width: 50px;
  }
  .recomm-services {
    .tbo-card-body > div {
      display: flex;
      text-align: center;
      justify-content: space-between;
      & > .service-item {
        flex: 0 1 140px;
      }
    }
  }
  .ticket-count {
    display: flex;
    .data-item {
      flex: 0 0 150px;
    }
  }
  .data-num {
    margin-top: 12px;
    margin-bottom: 6px;
  }
  .item-title {
    line-height: 20px;
    color: #60666e;
    font-weight: normal;
    user-select: none;
  }
  .service-icon {
    &.zicu {
      background-image: url(https://p1.meituan.net/codeman/2c2fe0838a03b3b8d8042cc7e263249f18851.png);
      transform: translateX(2px);
    }
    &.app {
      background-image: url(https://p1.meituan.net/codeman/5331caad0eb0e6afb6bda22b4b6cc18421787.png);
      transform: translateX(6px);
    }
    &.comment {
      background-image: url(https://p0.meituan.net/codeman/8b89b750442c710dd3e884aa08f0c33115747.png);
      transform: translateX(2px);
    }
    &.datacenter {
      background-image: url(https://p1.meituan.net/codeman/bdea4b67264db919242e48a0e0d185eb18628.png);
    }
  }
  .notices,
  .xigua-academy {
    flex: 1 0 50px;
    height: 524px;
  }
  .xigua-academy {
    .tbo-card-body {
      padding: 0 0 0 20px !important;
    }
  }
  .notices {
    margin-right: 20px;
    .tbo-card-body {
      padding: 0 20px !important;
    }
  }

  .xigua-academy {
    .tbo-card-body {
      padding: 0 0 0 20px;
    }
  }
  .notices {
    display: flex;
    flex-wrap: wrap;
    .separeate-block {
      height: 20px;
      width: 0;
    }
  }
  .course-list {
    list-style-type: none;
    height: 454px;
    overflow: hidden;
    &:before,
    &:after {
      display: table;
      clear: both;
      content: "";
    }
  }
  .create-selfpro {
    @include create-selfpro-tip;
  }
}
.code-result-info {
  font-size: 14px;
  & > h4 {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  & > .code-count-info {
    font-size: 30px;
    color: #ff8900;
    text-align: center;
  }
  & > .code-verify-info {
    display: flex;
    flex-wrap: wrap;
    & > p {
      flex: 1 1 50%;
      & > label {
        color: #7f7f7f;
      }
    }
  }
  & > .fee-info {
    margin-bottom: 7px;
    padding-bottom: 7px;
    box-shadow: inset 0 -0.5px 0 0 #dce3ea;
    .cost-detail-title {
      font-size: 16px;
      margin-bottom: 5px;
      color: #7f7f7f;
    }
    .cost-details {
      list-style-type: decimal;
      list-style-position: inside;
      & > li {
        margin-left: 1em;
      }
    }
  }
  .credentials-info {
    & li {
      color: #ff8900;
      padding: 5px;
      .tbo-btn {
        margin-left: 10px;
      }
    }
  }
}
.code-detail {
  .tbo-modal-footer {
    display: none;
  }
  .code-detail-info {
    font-size: 14px;
    & h4.code-detail-title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 10px;
    }
    & label {
      color: #7f7f7f;
    }
  }
  .from-package-product {
    color: red;
  }
  .code-order-info,
  .code-use-info,
  .price-valid-date,
  .voucher-holder,
  .credentials-info {
    margin-bottom: 7px;
    padding-bottom: 7px;
    box-shadow: inset 0 -0.5px 0 0 #dce3ea;
    align-items: baseline;
    display: flex;
    & > label {
      flex: 0 0 6em;
    }
    & > span,
    & > a {
      flex: 1 1 50px;
    }
    & li {
      color: #ff8900;
      padding: 5px;
      .tbo-btn {
        margin-left: 10px;
      }
    }
  }
  .voucher-holder {
    & > ul {
      & > li > label {
        width: 6em;
      }
    }
  }
  .voucher-code,
  .code-no-canuse {
    margin-bottom: 7px;
    padding-bottom: 7px;
    box-shadow: inset 0 -0.5px 0 0 #dce3ea;
    text-align: center;
    .tbo-select {
      width: 5em;
      margin: 0 5px 0 2px;
    }
    .price {
      color: #ff8900;
    }
  }
  .code-no-canuse {
    color: orange;
  }
  .cost-detail-part {
    margin-bottom: 7px;
    padding-bottom: 7px;
    box-shadow: inset 0 -0.5px 0 0 #dce3ea;
    .cost-detail-title {
      font-size: 16px;
      margin-bottom: 5px;
      color: #7f7f7f;
    }
    .cost-details {
      list-style-type: decimal;
      list-style-position: inside;
      & > li {
        margin-left: 1em;
      }
    }
  }
  .price-valid-date {
    & > span {
      color: #ff8900;
      flex: 1 1 50px;
      &.code-detail-money {
        font-size: 35px;
        .unit {
          font-size: 14px;
        }
      }
    }
  }
}
@import "./../custom.scss";
</style>



// WEBPACK FOOTER //
// homepage.vue?1b32c29c